import { StepData } from '@/lib/Steppers';

export type CreateCustomDestinationStep = 'selectCustomConnectorAudience' | 'selectCustomConnector' | 'configureCustomConnectorFlow' | 'sync';

export const CREATE_CUSTOM_CONNECTOR_STEPS: ReadonlyArray<StepData<CreateCustomDestinationStep>> = [
  {
    id: 'selectCustomConnectorAudience',
    title: 'ALL:destinations.steps.selectAudienceAndDestination.title',
  },
  {
    id: 'selectCustomConnector',
    title: 'ALL:destinations.steps.selectAudienceAndDestination.title',
  },
  {
    id: 'configureCustomConnectorFlow',
    title: 'ALL:destinations.steps.selectProperties.title',
  },
  {
    id: 'sync',
    title: 'ALL:destinations.steps.sync.title',
  },
] as const;
